import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';





const CUET_PricingsModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [subjects, setSubjects] = useState([]);

    let initialData = {
        ExamType: 'Select Subject type',
        Subject: "Select Subject",
        SubjectID: 0,
        TestCount: 0,
        Price: 0,
        Discount: 0,
        Sn: 0,
    }


    const [examBodyData, setExamBodyData] = useState(initialData);
    console.log(examBodyData);

    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setExamBodyData(item)
            }
            setModalBox(true);

        }
    }));
    useEffect(() => {
        if (examBodyData.ExamType && examBodyData.ExamType != 'Select Subject type') {
            axios.get(BACKEND_SERVER_URL + '/cuet/subjects/' + examBodyData.ExamType).then(res => {
                const subjects = res.data.subjects;
                setSubjects(subjects);
                if (examBodyData.SubjectID) {
                    setExamBodyData({ ...examBodyData, Subject: subjects.find(data => data.Sn == examBodyData.SubjectID).SubjectType });
                }
            })
        }

    }, [examBodyData.ExamType])


    const hanldeSaveExamBody = async () => {
        try {
            if (examBodyData.ExamType.trim().length === 0 || examBodyData.ExamType === 'Select Subject type') {
                toast.error("Please select subject type")
                return;
            } else if (examBodyData.TestCount <= 0) {
                toast.error("Please enter valid number of tests")
                return;
            } else if (examBodyData.Price <= 0) {
                toast.error("Please enter valid price")
                return;
            } else if (!examBodyData.SubjectID && examBodyData.ExamType !== 'Section-III') {
                toast.error("Please select any subject");
                return;
            }
            const response = await axios.post(BACKEND_SERVER_URL + `${!examBodyData.Sn ? '/cuet/createPlan' : `/cuet/updatePlan`}`, examBodyData);
            toast.success(response.data.message);
        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message)
        } finally {
            props.setSubjectLoading(!props.loadSubjects);
            setExamBodyData(initialData)
            setModalBox(false);
        }

    }
    return (
        <>
            <Modal onHide={setModalBox} show={modalBox} size="md" backdrop="static"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> {examBodyData.Sn ? "Update Pricing Plan" : "Add Pricing Plan"}</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="sessioncount" className="form-label text-primary">All SUBJECT<span className="required">*</span></label>
                            <Select
                                value={(() => {
                                    const options = [
                                        { value: 'Section-IA', label: 'Language Subjects' },
                                        { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                        { value: 'Section-III', label: 'General Aptitude Test' }
                                    ];
                                    return options.find(opt => opt.value === examBodyData.ExamType) || { value: examBodyData.ExamType, label: examBodyData.ExamType };
                                })()}
                                onChange={(selectedOption) => setExamBodyData({ ...examBodyData, ExamType: selectedOption.value })}
                                options={[
                                    { value: 'Section-IA', label: 'Language Subjects' },
                                    { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                    { value: 'Section-III', label: 'General Aptitude Test' }
                                ]}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent', // Adjust as needed
                                        borderColor: '#17a2b8', // Adjust as needed

                                    }),
                                }}
                            />
                        </div>
                        {
                            examBodyData.ExamType != 'Section-III' &&
                            <div className="mb-3">
                                <label htmlFor="sessioncount" className="form-label text-primary">SUBJECT NAME<span className="required">*</span></label>
                                <Select
                                    value={{ value: examBodyData.Subject, label: examBodyData.Subject }}
                                    onChange={(selectedOption) => {
                                        setExamBodyData({ ...examBodyData, SubjectID: selectedOption.value.Sn, Subject: selectedOption.value.SubjectType })
                                    }}
                                    options={subjects?.map((subjectObj) => ({ value: subjectObj, label: subjectObj.SubjectType }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            backgroundColor: 'transparent', // Adjust as needed
                                            borderColor: '#17a2b8', // Adjust as needed

                                        }),
                                    }}
                                />
                            </div>
                        }

                        <div className="mb-3">
                            <label htmlFor="subjects" className="form-label text-primary">No. of Tests<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="number" name="" id="subjects" value={examBodyData.TestCount} onChange={(e) => setExamBodyData({ ...examBodyData, TestCount: e.target.value })} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="subjects" className="form-label text-primary">Price<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="number" name="" id="subjects" value={examBodyData.Price} onChange={(e) => setExamBodyData({ ...examBodyData, Price: e.target.value })} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="subjects" className="form-label text-primary">Discount %<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="number" name="" id="subjects" value={examBodyData.Discount} onChange={(e) => setExamBodyData({ ...examBodyData, Discount: e.target.value })} />
                        </div>



                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs " onClick={hanldeSaveExamBody}>{examBodyData.Sn ? "Update Pricing Plan" : "Add Pricing Plan"}</button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default CUET_PricingsModal;